module.exports = __webpack_public_path__ + "static/media/3B073E_0_0.851ec9c1.woff2";